module.exports = __webpack_public_path__ + "img/2d30314.jpg";